import InputLine from './InputLine.vue';

InputLine.install = (Vue) => {
  Vue.component(InputLine.name, InputLine);
};

export default InputLine;
